module.exports = __webpack_public_path__ + "static/media/Microsoft_Partner.5e80171e.png";